<template>
  <div>
    <CContainer>
      <h1 class="sr-only">{{ $t("sidebar_items.consequences_ladder") }}</h1>
      <CRow class="justify-content-center mt-4">
        <CCol md="12 text-center">
          <TardyConsequencesLadderTable></TardyConsequencesLadderTable>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import { onMounted, onUnmounted, ref } from "vue"
import { useI18n } from "vue-i18n"
import TardyConsequencesLadderTable from "@/v3components/Datatables/TardyConsequencesLadderTable.vue"
export default {
  name: "TardyConsequencesLadder",
  components: { TardyConsequencesLadderTable },
  setup() {
    const { t } = useI18n()
    const previousDocumentTitle = ref("")

    onMounted(() => {
      previousDocumentTitle.value = document.title
      document.title = `${t("sidebar_items.consequences_ladder")} · Securly Pass`
    })

    onUnmounted(() => {
      document.title = previousDocumentTitle.value || "securlypass"
    })

    return {}
  }
}
</script>
